import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import Warehouse from "../warehouse/Warehouse";
import Client from "../../../../views/dashboard/models/Client";
import Role from "../role/Role";
import Country from "../country/Country";
import Image from "../image/Image";
import BankDetails from "./BankDetails";
import Payoneer from "./Payoneer";
import UserSettings from "./UserSettings";
import UserIdVerification from "./UserIdVerification";
import moment from "moment";
import PixelCollection from "../pixel/PixelCollection";
import ProductCollection from "../product/ProductCollection";
import UserCollection from "./UserCollection";
import SalePageCollection from "../salePage/SalePageCollection";
import OrderCollection from "../order/OrderCollection";
import SubscriptionPlan from "../SubscriptionPlan/SubscriptionPlan";
import JsonMappedUserPermissionModel from "../helpers/JsonMappedUserPermissionModel";
import PermissionCollection from "../permission/PermissionCollection";
import UserCustomData from "@/assets/js/models/user/UserCustomData";
var _attributes = /*#__PURE__*/new WeakMap();
export default class User extends JsonMappedUserPermissionModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [User.id_attribute_name]: null,
      [User.free_trial_eligible_attribute_name]: true,
      [User.subscription_plan_end_at_attribute_name]: true,
      [User.warehouse_id_attribute_name]: null,
      [User.next_subscription_plan_id_attribute_name]: null,
      [User.next_subscription_plan_attribute_name]: SubscriptionPlan,
      [User.subscription_plan_id_attribute_name]: null,
      [User.subscription_plan_attribute_name]: SubscriptionPlan,
      [User.advertiser_warehouse_attribute_name]: Warehouse,
      [User.call_agent_warehouse_attribute_name]: Warehouse,
      [User.user_warehouse_attribute_name]: Warehouse,
      [User.warehouse_attribute_name]: Warehouse,
      [User.user_manager_attribute_name]: User,
      [User.user_client_attribute_name]: Client,
      [User.user_name_attribute_name]: null,
      [User.full_name_attribute_name]: null,
      [User.email_attribute_name]: null,
      [User.user_role_attribute_name]: Role,
      [User.role_attribute_name]: Role,
      [User.country_attribute_name]: Country,
      [User.user_country_attribute_name]: Country,
      [User.country_id_attribute_name]: null,
      [User.company_attribute_name]: null,
      [User.phone_attribute_name]: null,
      [User.advertiser_type_attribute_name]: null,
      [User.skype_id_attribute_name]: null,
      [User.seller_status_attribute_name]: null,
      [User.user_status_attribute_name]: null,
      [User.user_image_attribute_name]: Image,
      [User.image_attribute_name]: Image,
      [User.avatar_attribute_name]: Image,
      [User.created_at_attribute_name]: null,
      [User.email_verified_at_attribute_name]: null,
      [User.user_confirmed_sales_attribute_name]: null,
      [User.call_agent_type_attribute_name]: null,
      [User.user_total_confirmed_earnings_attribute_name]: null,
      [User.user_pixels_attribute_name]: PixelCollection,
      [User.permissions_attribute_name]: PermissionCollection,
      [User.json_permissions_attribute_name]: [],
      [User.call_agent_products_attribute_name]: ProductCollection,
      [User.manager_users_attribute_name]: UserCollection,
      [User.user_sale_pages_attribute_name]: SalePageCollection,
      [User.call_agent_orders_attribute_name]: OrderCollection,
      [User.last_30_days_earnings_attribute_name]: null,
      [User.news_letter_subscribed_attribute_name]: null,
      [User.user_instagram_link_verification_attribute_name]: null,
      [User.user_instagram_link_attribute_name]: null,
      [User.user_youtube_link_attribute_name]: null,
      [User.seller_conversion_tracking_url_attribute_name]: null,
      [User.user_speaking_language_attribute_name]: null,
      [User.activity_points_attribute_name]: null,
      [User.logged_at_attribute_name]: null,
      [User.experience_description_attribute_name]: null,
      [User.user_bank_details_attribute_name]: BankDetails,
      [User.bank_details_attribute_name]: BankDetails,
      [User.user_payoneer_attribute_name]: Payoneer,
      [User.payoneer_attribute_name]: Payoneer,
      [User.payment_method_attribute_name]: User.BANK_TRANSFER_PAYMENT_METHOD,
      [User.referral_id_attribute_name]: null,
      [User.referrer_attribute_name]: User,
      [User.last_thirty_days_delivered_sales_attribute_name]: null,
      [User.last_thirty_days_delivered_earnings_attribute_name]: null,
      [User.last_thirty_days_delivered_orders_attribute_name]: null,
      [User.settings_attribute_name]: UserSettings,
      [User.has_payment_info_attribute_name]: null,
      [User.identity_verification_attribute_name]: UserIdVerification,
      [User.custom_data_attribute_name]: UserCustomData,
      [User.referred_from_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return User.id_attribute_name;
  }
  static getImageAttributeName() {
    return User.image_attribute_name;
  }
  static getUserNameAttributeName() {
    return User.user_name_attribute_name;
  }
  static getEmailAttributeName() {
    return User.email_attribute_name;
  }
  static getPhoneAttributeName() {
    return User.phone_attribute_name;
  }
  static getSkypeIdAttributeName() {
    return User.skype_id_attribute_name;
  }
  static getCompanyAttributeName() {
    return User.company_attribute_name;
  }
  static getCountryAttributeName() {
    return User.country_attribute_name;
  }
  static getCountryIdAttributeName() {
    return User.country_id_attribute_name;
  }
  static getRoleAttributeName() {
    return User.role_attribute_name;
  }
  static getUserRoleAttributeName() {
    return User.user_role_attribute_name;
  }
  static getUserStatusAttributeName() {
    return User.user_status_attribute_name;
  }
  static getSellerStatusAttributeName() {
    return User.seller_status_attribute_name;
  }
  static getActivityPointsAttributeName() {
    return User.activity_points_attribute_name;
  }
  static isSubscribedToNewsLetterAttributeName() {
    return User.news_letter_subscribed_attribute_name;
  }
  static getFullNameAttributeName() {
    return User.full_name_attribute_name;
  }
  static getNextSubscriptionPlanAttributeName() {
    return this.next_subscription_plan_attribute_name;
  }
  static getNextSubscriptionPlanIdAttributeName() {
    return this.next_subscription_plan_id_attribute_name;
  }
  static getSubscriptionPlanAttributeName() {
    return this.subscription_plan_attribute_name;
  }
  static getSubscriptionPlanIdAttributeName() {
    return this.subscription_plan_id_attribute_name;
  }
  static getSpeakingLanguageAttributeName() {
    return this.user_speaking_language_attribute_name;
  }
  static getReferrerAttributeName() {
    return this.referrer_attribute_name;
  }
  static getPaymentMethodAttributeName() {
    return this.payment_method_attribute_name;
  }
  static getUserBankDetailsAttributeName() {
    return this.user_bank_details_attribute_name;
  }
  static getUserPayoneerAttributeName() {
    return this.user_payoneer_attribute_name;
  }
  static getSettingsAttributeName() {
    return this.settings_attribute_name;
  }
  static getCustomDataAttributeName() {
    return this.custom_data_attribute_name;
  }
  static getReferredFromAttributeName() {
    return this.referred_from_attribute_name;
  }
  getReferredFrom() {
    return this.getAttribute(User.getReferredFromAttributeName());
  }
  getCustomData() {
    return this.getAttribute(User.getCustomDataAttributeName());
  }
  getProductTries() {
    const customData = this.getCustomData();
    return customData instanceof UserCustomData ? customData.getProductTries() : null;
  }
  getSalePageTries() {
    const customData = this.getCustomData();
    return customData instanceof UserCustomData ? customData.getSalePageTries() : null;
  }
  getIdentityVerification() {
    return this.getAttribute(User.identity_verification_attribute_name);
  }
  getLast30DaysDeliveredOrders() {
    return this.getAttribute(User.last_thirty_days_delivered_orders_attribute_name);
  }
  hasPaymentInfo() {
    return this.getAttribute(User.has_payment_info_attribute_name);
  }
  getId() {
    return this.getAttribute(User.id_attribute_name);
  }
  getName() {
    return this.getAttribute(User.user_name_attribute_name);
  }
  getWarehouseId() {
    return this.getAttribute(User.warehouse_id_attribute_name);
  }
  getUserWarehouse() {
    return this.getAttribute(User.user_warehouse_attribute_name);
  }
  getWarehouse() {
    return this.getAttribute(User.warehouse_attribute_name);
  }
  getUserWarehouseId() {
    let userWarehouse = this.getUserWarehouse();
    return userWarehouse instanceof Warehouse ? userWarehouse.getId() : null;
  }
  getInfluencerClient() {
    return this.getAttribute(User.user_client_attribute_name);
  }
  getCallAgentType() {
    return this.getAttribute(User.call_agent_type_attribute_name);
  }
  isMainCallAgent() {
    return this.getCallAgentType() === User.CALL_AGENT_MAIN_TYPE;
  }
  getSettings() {
    return this.getAttribute(User.settings_attribute_name);
  }
  getLastThirtyDaysDeliveredSales() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(User.last_thirty_days_delivered_sales_attribute_name)) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : 0;
  }
  getPixels() {
    var _this$getAttribute2;
    return (_this$getAttribute2 = this.getAttribute(User.user_pixels_attribute_name)) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : [];
  }
  getPostBackUrl() {
    return this.getAttribute(User.seller_conversion_tracking_url_attribute_name);
  }
  getReferrer() {
    return this.getAttribute(User.referrer_attribute_name);
  }
  getAdvertiserType() {
    return this.getAttribute(User.advertiser_type_attribute_name);
  }
  getReferrerName() {
    let referrer = this.getReferrer();
    return referrer instanceof User ? referrer.getUserName() : null;
  }
  getSignupDate() {
    return this.getAttribute(User.created_at_attribute_name);
  }
  getSkype() {
    return this.getAttribute(User.skype_id_attribute_name);
  }
  isSubscribedToNewsletter() {
    return this.getAttribute(User.news_letter_subscribed_attribute_name);
  }
  getManager() {
    return this.getAttribute(User.user_manager_attribute_name);
  }
  getManagerName() {
    let manager = this.getManager();
    return manager instanceof User ? manager.getUserName() : null;
  }
  getYoutubeChannelLink() {
    return this.getAttribute(User.user_youtube_link_attribute_name);
  }
  getInstagramProfileLink() {
    return this.getAttribute(User.user_instagram_link_attribute_name);
  }
  getSellerStatus() {
    return this.getAttribute(User.seller_status_attribute_name);
  }
  getExperienceDescription() {
    return this.getAttribute(User.experience_description_attribute_name);
  }
  getCompanyName() {
    return this.getAttribute(User.company_attribute_name);
  }
  static getJsonPermissionsAttributeName() {
    return User.json_permissions_attribute_name;
  }
  static getFreeTrialEligibleAttributeName() {
    return User.free_trial_eligible_attribute_name;
  }
  static getSubscriptionPlanEndAtAttributeName() {
    return User.subscription_plan_end_at_attribute_name;
  }
  getReferralId() {
    return this.getAttribute(User.referral_id_attribute_name);
  }
  static getPaymentMethods() {
    return [User.BANK_TRANSFER_PAYMENT_METHOD, User.PAYONEER_PAYMENT_METHOD];
  }
  hasPaymentMethod() {
    return User.getPaymentMethods().includes(this.getPaymentMethod());
  }
  getPaymentMethod() {
    return this.getAttribute(User.payment_method_attribute_name);
  }
  getLoggedAt() {
    return this.getAttribute(User.logged_at_attribute_name);
  }
  getActivityPoints() {
    return this.getAttribute(User.activity_points_attribute_name);
  }
  getCreatedAt() {
    return this.getAttribute(User.created_at_attribute_name);
  }
  getLoggedAtStatus() {
    let from = this.getLoggedAt();
    let to = new Date();
    let hours = moment.duration({
      from: from,
      to: to
    }).asHours();
    /*        if (this.getId() === 1) {
                console.log('from', from)
                console.log('from converted', new Date(from))
                console.log('from moment', moment(from))
                console.log('to', to)
                console.log('hours', hours)
            }*/
    return from || from === 0 ? hours <= 24 ? 'success' : hours <= 72 ? 'warning' : 'danger' : 'danger';
  }
  getLoggedInFromNow(lang = 'en') {
    let date = this.getLoggedAt();
    return moment(date).isValid() ? moment(date).locale(lang).fromNow() : 'unknown';
  }
  isActive() {
    return this.getStatus() === User.ACTIVE_STATUS;
  }
  getUserName() {
    return this.getAttribute(User.user_name_attribute_name);
  }
  isInactive() {
    return this.getStatus() === User.INACTIVE_STATUS || !this.getStatus();
  }
  getUserEmail() {
    return this.getAttribute(User.email_attribute_name);
  }
  getEmail() {
    return this.getAttribute(User.email_attribute_name);
  }
  getUserCountry() {
    return this.getAttribute(User.user_country_attribute_name);
  }
  getCountry() {
    return this.getAttribute(User.country_attribute_name);
  }
  getStatus() {
    return this.getAttribute(User.user_status_attribute_name);
  }
  getFullName() {
    return this.getAttribute(User.full_name_attribute_name);
  }
  getUserPhone() {
    return this.getAttribute(User.phone_attribute_name);
  }
  isWarehouse() {
    const role = this.getRole();
    return role instanceof Role && role.isWarehouse();
  }
  isSeller() {
    const role = this.getRole();
    return role instanceof Role && role.isSeller();
  }
  isAffiliate() {
    const role = this.getRole();
    return role instanceof Role && role.isAffiliate();
  }
  getTutorials() {
    const role = this.getRole();
    return role instanceof Role ? role.getTutorials() : [];
  }
  isStandard() {
    return this.getSellerStatus() === 'standard';
  }
  getUserImage() {
    var _this$getAttribute3;
    return (_this$getAttribute3 = this.getAttribute(User.user_image_attribute_name)) !== null && _this$getAttribute3 !== void 0 ? _this$getAttribute3 : this.getAttribute(User.image_attribute_name);
  }
  getImage() {
    var _ref, _this$getAttribute4;
    return (_ref = (_this$getAttribute4 = this.getAttribute(User.user_image_attribute_name)) !== null && _this$getAttribute4 !== void 0 ? _this$getAttribute4 : this.getAttribute(User.image_attribute_name)) !== null && _ref !== void 0 ? _ref : this.getAttribute(User.avatar_attribute_name);
  }
  getPhoneNumber() {
    return this.getAttribute(User.phone_attribute_name);
  }
  getUserImageUrl() {
    return this.getUserImage();
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getUserRole() {
    var _this$getAttribute5;
    return (_this$getAttribute5 = this.getAttribute(User.user_role_attribute_name)) !== null && _this$getAttribute5 !== void 0 ? _this$getAttribute5 : this.getAttribute(User.role_attribute_name);
  }
  getRole() {
    var _this$getAttribute6;
    return (_this$getAttribute6 = this.getAttribute(User.user_role_attribute_name)) !== null && _this$getAttribute6 !== void 0 ? _this$getAttribute6 : this.getAttribute(User.role_attribute_name);
  }
  getUserRoleName() {
    let role = this.getUserRole();
    return role instanceof Role ? role.getName() : null;
  }
  getRoleName() {
    let role = this.getRole();
    return role instanceof Role ? role.getName() : null;
  }
  getResolvedUserImageUrl() {
    let imageUrl = this.getImageUrl();
    if (imageUrl) return imageUrl;
    switch (this.getUserRoleName()) {
      case Role.ADMIN_ROLE:
        return require('../../../boss.svg');
      case Role.MANAGER_ROLE:
        return require('../../../business-man.svg');
      case Role.WAREHOUSE_ROLE:
        return require('../../../delivery-man.svg');
      case Role.CALL_AGENT_ROLE:
        return require('../../../call-agent.svg');
      default:
        return require('../../../img/account_avatar.png');
    }
  }
  getUserSelectObject(text = 'text', value = 'value') {
    return {
      [text]: this.getUserName(),
      [value]: this.getId()
    };
  }
  getAdvertiserWarehouse() {
    return this.getAttribute(User.warehouse_id_attribute_name);
  }
  getPermissions() {
    return this.getAttribute(User.permissions_attribute_name);
  }
  getJsonPermissions() {
    var _this$getAttribute7;
    return (_this$getAttribute7 = this.getAttribute(User.json_permissions_attribute_name)) !== null && _this$getAttribute7 !== void 0 ? _this$getAttribute7 : [];
  }
  isPermitted(permission) {
    if (!permission) return true;
    if (Array.isArray(permission)) {
      return this.isPermittedInEvery(permission);
    }
    return this.getJsonPermissions().some(jsonPermission => new RegExp(`^${permission}`).exec(jsonPermission));
  }
  isSomePermitted(permission) {
    if (Array.isArray(permission) && !permission.length) return true;
    return this.isPermittedInSome(permission);
  }
  isRolePermitted(role) {
    return Array.isArray(role) ? role.length < 1 || role.includes('*') || role.includes(this.getRoleName()) : !role || role === this.getRoleName();
  }
  isPermittedInEvery(permissions) {
    if (!Array.isArray(permissions)) {
      return this.isPermitted(permissions);
    }
    return permissions.every(permission => this.isPermitted(permission));
  }
  isPermittedInSome(permissions) {
    if (!Array.isArray(permissions)) {
      return this.isPermitted(permissions);
    }
    return permissions.some(permission => this.isPermitted(permission));
  }
  isEmailVerified() {
    return this.getAttribute(User.email_verified_at_attribute_name);
  }
  getBankDetails() {
    return this.getAttribute(User.bank_details_attribute_name);
  }
  getPayoneer() {
    return this.getAttribute(User.payoneer_attribute_name);
  }
  getNextSubscriptionPlan() {
    return this.getAttribute(User.getNextSubscriptionPlanAttributeName());
  }
  getSubscriptionPlan() {
    return this.getAttribute(User.getSubscriptionPlanAttributeName());
  }
  inBasicPlan() {
    const subscriptionPlan = this.getSubscriptionPlan();
    return subscriptionPlan instanceof SubscriptionPlan && subscriptionPlan.isBasicPlan();
  }
  getPlanPermissions() {
    let subscriptionPlan = this.getSubscriptionPlan();
    return subscriptionPlan instanceof SubscriptionPlan ? subscriptionPlan.getPermissions() : [];
  }
  hasPlanPermission(permission) {
    let subscriptionPlan = this.getSubscriptionPlan();
    return subscriptionPlan instanceof SubscriptionPlan ? subscriptionPlan.isPermitted(permission) : [];
  }
}
_defineProperty(User, "ACTIVE_STATUS", 'active');
_defineProperty(User, "INACTIVE_STATUS", 'inactive');
_defineProperty(User, "SUSPENDED_STATUS", 'suspended');
_defineProperty(User, "SOLO_ADVERTISER_TYPE", 'solo');
_defineProperty(User, "HYBRID_ADVERTISER_TYPE", 'hybrid');
_defineProperty(User, "INDEPENDENT_ADVERTISER_TYPE", 'independent');
_defineProperty(User, "STANDARD_SELLER_STATUS", 'standard');
_defineProperty(User, "EXCLUSIVE_SELLER_STATUS", 'exclusive');
_defineProperty(User, "PRIVATE_SELLER_STATUS", 'private');
_defineProperty(User, "TEST_SELLER_STATUS", 'test');
_defineProperty(User, "BANK_TRANSFER_PAYMENT_METHOD", 'bank-transfer');
_defineProperty(User, "PAYONEER_PAYMENT_METHOD", 'payoneer');
_defineProperty(User, "CALL_AGENT_MAIN_TYPE", 'main');
_defineProperty(User, "REFERRED_FROM_YOUTUBE", 'youtube');
_defineProperty(User, "REFERRED_FROM_FACEBOOK", 'facebook');
_defineProperty(User, "REFERRED_FROM_INSTAGRAM", 'instagram');
_defineProperty(User, "REFERRED_FROM_GOOGLE", 'google');
_defineProperty(User, "REFERRED_FROM_FRIEND", 'friend');
_defineProperty(User, "REFERRED_FROM_OTHER", 'other');
_defineProperty(User, "id_attribute_name", 'user_id');
_defineProperty(User, "warehouse_id_attribute_name", 'warehouse_id');
_defineProperty(User, "advertiser_warehouse_attribute_name", 'advertiser_warehouse');
_defineProperty(User, "call_agent_warehouse_attribute_name", 'call_agent_warehouse');
_defineProperty(User, "user_warehouse_attribute_name", 'user_warehouse');
_defineProperty(User, "warehouse_attribute_name", 'warehouse');
_defineProperty(User, "user_manager_attribute_name", 'user_manager');
_defineProperty(User, "user_client_attribute_name", 'user_client');
_defineProperty(User, "user_name_attribute_name", 'user_name');
_defineProperty(User, "full_name_attribute_name", 'user_full_name');
_defineProperty(User, "email_attribute_name", 'user_email');
_defineProperty(User, "user_role_attribute_name", 'user_role');
_defineProperty(User, "role_attribute_name", 'role');
_defineProperty(User, "user_country_attribute_name", 'user_country');
_defineProperty(User, "country_attribute_name", 'user_country');
_defineProperty(User, "country_id_attribute_name", 'country_id');
_defineProperty(User, "company_attribute_name", 'user_company');
_defineProperty(User, "phone_attribute_name", 'user_phone');
_defineProperty(User, "advertiser_type_attribute_name", 'advertiser_type');
_defineProperty(User, "skype_id_attribute_name", 'user_skype_id');
_defineProperty(User, "seller_status_attribute_name", 'seller_status');
_defineProperty(User, "user_status_attribute_name", 'user_status');
_defineProperty(User, "user_image_attribute_name", 'user_image');
_defineProperty(User, "image_attribute_name", 'image');
_defineProperty(User, "avatar_attribute_name", 'avatar');
_defineProperty(User, "created_at_attribute_name", 'created_at');
_defineProperty(User, "email_verified_at_attribute_name", 'email_verified_at');
_defineProperty(User, "user_confirmed_sales_attribute_name", 'user_confirmed_sales');
_defineProperty(User, "call_agent_type_attribute_name", 'call_agent_type');
_defineProperty(User, "user_total_confirmed_earnings_attribute_name", 'user_total_confirmed_earnings');
_defineProperty(User, "user_pixels_attribute_name", 'user_pixels');
_defineProperty(User, "permissions_attribute_name", 'permissions');
_defineProperty(User, "call_agent_products_attribute_name", 'call_agent_products');
_defineProperty(User, "manager_users_attribute_name", 'manager_users');
_defineProperty(User, "user_sale_pages_attribute_name", 'user_sale_pages');
_defineProperty(User, "call_agent_orders_attribute_name", 'call_agent_orders');
_defineProperty(User, "last_30_days_earnings_attribute_name", 'last_30_days_earnings');
_defineProperty(User, "news_letter_subscribed_attribute_name", 'user_news_letter_subscribed');
_defineProperty(User, "user_instagram_link_verification_attribute_name", 'user_instagram_link_verification');
_defineProperty(User, "user_instagram_link_attribute_name", 'user_instagram_link');
_defineProperty(User, "user_youtube_link_attribute_name", 'user_youtube_link');
_defineProperty(User, "seller_conversion_tracking_url_attribute_name", 'seller_conversion_tracking_url');
_defineProperty(User, "user_speaking_language_attribute_name", 'user_speaking_language');
_defineProperty(User, "activity_points_attribute_name", 'user_activity_points');
_defineProperty(User, "logged_at_attribute_name", 'logged_at');
_defineProperty(User, "experience_description_attribute_name", 'experience_description');
_defineProperty(User, "user_bank_details_attribute_name", 'user_bank_details');
_defineProperty(User, "bank_details_attribute_name", 'bank_details');
_defineProperty(User, "user_payoneer_attribute_name", 'user_payoneer');
_defineProperty(User, "payoneer_attribute_name", 'payoneer');
_defineProperty(User, "payment_method_attribute_name", 'payment_method');
_defineProperty(User, "referral_id_attribute_name", 'referral_id');
_defineProperty(User, "referrer_attribute_name", 'referrer');
_defineProperty(User, "last_thirty_days_delivered_sales_attribute_name", 'last_thirty_days_delivered_sales');
_defineProperty(User, "last_thirty_days_delivered_earnings_attribute_name", 'last_thirty_days_delivered_earnings');
_defineProperty(User, "last_thirty_days_delivered_orders_attribute_name", 'last_thirty_days_delivered_orders');
_defineProperty(User, "settings_attribute_name", 'settings');
_defineProperty(User, "has_payment_info_attribute_name", 'has_payment_info');
_defineProperty(User, "identity_verification_attribute_name", 'identity_verification');
_defineProperty(User, "next_subscription_plan_id_attribute_name", 'next_subscription_plan_id');
_defineProperty(User, "next_subscription_plan_attribute_name", 'next_subscription_plan');
_defineProperty(User, "subscription_plan_id_attribute_name", 'subscription_plan_id');
_defineProperty(User, "subscription_plan_attribute_name", 'subscription_plan');
_defineProperty(User, "json_permissions_attribute_name", 'json_permissions');
_defineProperty(User, "free_trial_eligible_attribute_name", 'free_trial_eligible');
_defineProperty(User, "subscription_plan_end_at_attribute_name", 'subscription_plan_end_at');
_defineProperty(User, "custom_data_attribute_name", 'custom_data');
_defineProperty(User, "referred_from_attribute_name", 'referred_from');